import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { AreaContainer } from '../../containers/filters/AreaContainer';
import { IFilter } from '../../types/filters';

export const area: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: AreaContainer,
};
